import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/currency/mh_logo.png'
import _imports_1 from '@/assets/login/evaluation.png'


const _withScopeId = n => (_pushScopeId("data-v-002bd70f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dvBJ" }
const _hoisted_2 = {
  key: 0,
  class: "loginLoadingMask"
}
const _hoisted_3 = { class: "loginLoadingText" }
const _hoisted_4 = { class: "dvTop" }
const _hoisted_5 = {
  key: 0,
  class: "dvTopLeft"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "机灵树"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dvTopLeftTitle" }, "· 艺术素质测评系统", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "dvTopNoLogo"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "noLogo",
  src: _imports_1
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "dvBottom" }
const _hoisted_13 = { class: "dvBottomCard" }
const _hoisted_14 = { class: "dvBottomCardLogin" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "sp" }, "学生登录")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dvLine" }, null, -1))
const _hoisted_17 = { class: "dvInput mt7" }
const _hoisted_18 = { class: "dvElInput" }
const _hoisted_19 = { class: "dvInput mt7" }
const _hoisted_20 = { class: "dvElInput" }
const _hoisted_21 = { class: "mt10 dvLoginBtn" }
const _hoisted_22 = { class: "deviceCheckBtn" }
const _hoisted_23 = {
  key: 1,
  class: "version"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading == true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.loadingText), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (!_ctx.store.state.noLogo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_el_input, {
                placeholder: "请输入账号",
                modelValue: _ctx.account,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.account) = $event)),
                clearable: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_el_input, {
                placeholder: "请输入登录密码",
                modelValue: _ctx.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                clearable: "",
                "show-password": ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("button", {
              class: "btnLogin",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.btnLogin && _ctx.btnLogin(...args)))
            }, "登 录")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", {
        class: "dvTopRightBtn",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToDeviceCheck && _ctx.goToDeviceCheck(...args)))
      }),
      _createElementVNode("div", {
        class: "dvCloseBtn",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeApp && _ctx.closeApp(...args)))
      })
    ]),
    (_ctx.store.state.version)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, " v" + _toDisplayString(_ctx.store.state.version), 1))
      : _createCommentVNode("", true)
  ]))
}